export const deviceType = {
    PHONE: 'Phone',
    TABLET: 'Tablet',
    DESKTOP: 'Desktop'
};


// WEBPACK FOOTER //
// ./src/helper/enum/deviceType.js